var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbDownOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996 14H6.29428C4.92586 14 4.32937 13.2982 4.57499 11.9298L5.48727 6.87719C5.69779 5.73684 6.57499 5 7.75042 5H15.996V14.807L14.0662 19.6316C14.0136 19.7368 13.996 19.8772 13.996 20C13.996 20.5439 14.4522 21 14.996 21C15.4171 21 15.7855 20.7368 15.9259 20.3684L17.996 15.193V3H7.75042C5.71534 3 3.89078 4.54386 3.52235 6.52632L2.61007 11.5789C2.17148 14.0175 3.83814 16 6.29428 16H11.996C12.5399 16 12.996 15.5439 12.996 15C12.996 14.4561 12.5399 14 11.996 14ZM17.996 16C20.2417 16 21.996 14.2456 21.996 12V7C21.996 4.75438 20.2417 3 17.996 3H15.996V16H17.996ZM17.996 14V5C19.2592 5 19.996 5.73684 19.996 7V12C19.996 13.2632 19.2592 14 17.996 14ZM14.996 19C13.7329 19 12.996 18.2632 12.996 17V15C12.996 14.4561 12.5399 14 11.996 14C11.4522 14 10.996 14.4561 10.996 15V17C10.996 19.2456 12.7504 21 14.996 21C15.5399 21 15.996 20.5439 15.996 20C15.996 19.4561 15.5399 19 14.996 19Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownOutlined);
export default __webpack_public_path__ + "static/media/thumb_down_outlined.89ec6797.svg";
export { ForwardRef as ReactComponent };